const STATES = [
  { name: 'Australian Capital Territory', value: 'ACT' },
  { name: 'New South Wales', value: 'NSW' },
  { name: 'Northern Territory', value: 'NT' },
  { name: 'Queensland', value: 'QLD' },
  { name: 'South Australia', value: 'SA' },
  { name: 'Tasmania', value: 'TAS' },
  { name: 'Victoria', value: 'VIC' },
  { name: 'Western Australia', value: 'WA' },
]

export enum Regions {
  AUNZ = 'AU & NZ',
  UK = 'UK',
}

export const regionToLinksMap = {
  [Regions.AUNZ]: '/',
  [Regions.UK]: '/uk',
}

export const regionNames: Record<Regions, string> = {
  [Regions.AUNZ]: 'Australia & New Zealand',
  [Regions.UK]: 'United Kingdom',
}

export default STATES
